import { useEffect, useState } from "react"
import { api } from "../env"
import Loading from "../components/loading"
import Input, { clearForm, required, submitForm, useInput } from "../components/input"
import LoadingButton from "../components/LoadingButton"
import Title from "../components/Title"
import ErrorFrame from "../components/error"

export default function Account() {

    const [profile, setProfile] = useState(undefined)
    const [loading, setLoading] = useState(true)

    const getProfile = () => {
        setLoading(true)
        api.get('accounts/me/profile')
            .then(res => {
                setProfile(res.data)
                setLoading(false)
            })
            .catch(_ => setLoading(false))
    }

    useEffect(() => getProfile(), [])

    return(<div className="standard-padding page-m-centered">
        {loading && <Loading message={'Loading Account Information...'}/>}
        {!loading && !profile && <ErrorFrame message={'An error occurred'} onAction={getProfile}/>}
        {!loading && profile && <>
            {profile?.type === 'Participant' && <Title className={'v-spacer-xs'}>Account</Title>}
            {profile?.type !== 'Participant' && <p className="section-title v-spacer-xs">Account</p>}
            <AccountDetails profile={profile}/>
            <div className="v-spacer-xxl"></div>
            <p className="section-title-s v-spacer-xs">Reset Password</p>
            <ResetPassword />
        </>}
    </div>)
}

function AccountDetails({profile}) {
    return(<div className="card">
        <p className="card-title v-spacer-m">{profile.firstName} {profile.lastName}</p>
        <div className="data-grid">
            <p className="key-item">Email</p>
            <p className="value-item">{profile.email}</p>
            <p className="key-item">Role</p>
            <p className="value-item">{profile.type}</p>
        </div>
    </div>)
}

function ResetPassword({}) {

    const [loading, setLoading] = useState(false)

    const resetPasswordForm = {
        oldPassword: useInput("Old Password", "key", "password", [required]),
        newPassword: useInput("New Password", "lock_open", "password", [required]), 
        repeatPassword: useInput("Repeat Password", "lock", "password", [required]) 
    }

    const handleReset = () => {
        const resetPassword = submitForm(resetPasswordForm)
        if (!resetPassword) return
        setLoading(true)
        const {repeatPassword, ...body} = resetPassword
        api.put('accounts/password', body)
            .then(res => {
                clearForm(resetPasswordForm)
                setLoading(false)
            })
            .catch(err => {})
        
    }

    return(<div className="card flex columns gap-xs">
        <Input state={resetPasswordForm.oldPassword}/>
        <Input state={resetPasswordForm.newPassword}/>
        <Input state={resetPasswordForm.repeatPassword}/>
        <div className="flex justify-end">
            <LoadingButton className={'solid-accent'} label={'Reset Password'} loading={loading} onClick={handleReset}/>
        </div>
    </div>)
}